<div class="analyst-ratings-card additional-insights-card container default-padding"
     [ngClass]="{enabled: !!ratings?.hasMinimumRequiredRatingCount()}" matRipple
     [matRippleDisabled]="!ratings?.hasMinimumRequiredRatingCount()" (click)="handleClick()">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <div class="icon-container container" fxLayoutAlign="center center">
      <fa-icon class="primary-icon" icon="star-half-alt"></fa-icon>
    </div>
    <div class="info-container container" fxFlex fxLayout="column">
      <strong>{{title}}</strong>
      <small class="color-muted">{{description}}</small>
    </div>
  </div>
  <mtn-restricted-license-overlay *ngIf="isRestrictedLicenseOverlayEnabled" [buttonSize]="Size.EXTRA_SMALL"
                                  [bannerSize]="Size.EXTRA_SMALL"></mtn-restricted-license-overlay>
</div>
